import React, { useEffect } from 'react'
import { HolyDayType } from '../../types/holiday/types'
import moment from 'moment-jalaali'
import { enToPersianChar } from '../activities'
import { getDateOfTimeZoneDate, monthNames, returnSeparatedDayMonth } from '../../shared/helper'

// import { useSelector } from 'react-redux'
// import { useDispatch } from 'react-redux'
// import { IRootState } from '../../../service/store'
// import { IHoliday, IHolidayDataObject } from '../../../service/interfaces/holiday'
// import { getHolidayRequestAction } from '../../../service/actions/calendarHolidayAction'

export const Holidays = ({ holidays }: { holidays: HolyDayType[] }) => {
    // const holidayList: IHolidayDataObject | null = useSelector((state: IRootState) => state.calendarHoliday.holidays)
    // const getHolidayPending: boolean = useSelector((state: IRootState) => state.calendarHoliday.getHolidayPending)

    // const dispatch = useDispatch()


    useEffect(() => {
        // dispatch(getHolidayRequestAction({
        //     whereConditionText: "",
        //     pageNumber: 1,
        //     pageSize: 20,
        //     disablePaging: true,
        //     sortText: ''
        // }))
    }, [])
    return (
        <div className='holidays-container'>
            <ul>
                {holidays.map((item: HolyDayType, idx: number) => {
                    const { month, day } = returnSeparatedDayMonth(item.date)
                    return (<li key={idx}>
                        <div>   <label>{enToPersianChar(idx + 1)}-</label></div>
                        <div>

                            <label>

                                <span> {enToPersianChar(day)}</span>
                                {monthNames(month)}
                            </label>
                        </div>
                        <div>{item.title}</div>
                    </li>)
                })}
            </ul>
        </div>
    )
}
